<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Detalle de Liquidaciones</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-sm-12">
          <card body-classes="p-0" footer-classes="pb-2">
            <template slot="header">
              <h3 class="mb-0">Detalle de Liquidaciones</h3>
            </template>

            <div v-if="orders.length > 0" class="table-responsive">
              <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap my-5">
                <el-select v-model="pagination.perPage" class="select-primary pagination-select" placeholder="Per page">
                  <el-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                    class="select-primary"
                  ></el-option>
                </el-select>
              </div>
              <el-table :data="orders" header-row-class-name="thead-light">
                <el-table-column label="Fecha" min-width="120px" prop="date">
                  <template #default="{ row }">
                    <span>{{ row.date | date }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="N° Pedido" min-width="130px" prop="code">
                  <template #default="{ row }">
                    <span>{{ row.code }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="Campaña" min-width="120px" prop="campaign">
                  <template #default="{ row }">
                    <span>{{ row.campaign.name }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="Razón Social" min-width="120px" prop="producer">
                  <template #default="{ row }">
                    <span>{{ row.producer.businessName }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="Distribuidor" min-width="120px" prop="distributor">
                  <template #default="{ row }">
                    <span>{{ row.producer.distributor.name }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="Asesor Técnico" min-width="120px" prop="seller">
                  <template #default="{ row }">
                    <span>{{ row.producer.distributor.seller.name }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="Total" min-width="120px" prop="total">
                  <template #default="{ row }">
                    <span>{{ row.total | toCurrencyUSD }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="Total en Pesos" min-width="120px" prop="totalInPesos">
                  <template #default="{ row }">
                    <span>{{ row.totalInPesos | toCurrencyARS }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="Comision Distribuidor" min-width="120px" prop="totalCommissionDistributor">
                  <template #default="{ row }">
                    <span>{{ ((row.distributorCommission / 100) * row.totalInPesos) | toCurrencyARS }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="Com. %" min-width="120px" prop="percentageCommissionDistributor">
                  <template #default="{ row }">
                    <span>{{ (row.distributorCommission / 100) | percentage }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="Comision Asesor" min-width="120px" prop="totalCommissionSeller">
                  <template #default="{ row }">
                    <span>{{ ((row.sellerCommission / 100) * row.totalInPesos) | toCurrencyARS }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="Com. %" min-width="120px" prop="percentageCommissionSeller">
                  <template #default="{ row }">
                    <span>{{ (row.sellerCommission / 100) | percentage }}</span>
                  </template>
                </el-table-column>
              </el-table>

              <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap mt-5">
                <div class="">
                  <p class="card-category">
                    Mostrando {{ from + 1 }} a {{ to }} de un total de {{ pagination.total }} liquidaciones
                  </p>
                </div>
                <base-pagination
                  v-model="pagination.currentPage"
                  :per-page="pagination.perPage"
                  :show-first-page-button="true"
                  :show-last-page-button="true"
                  :total="pagination.total"
                  class="pagination-no-border"
                  @input="changePage"
                >
                </base-pagination>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from 'element-ui';
import { BasePagination } from '@/components';
import { STATE_FINALIZED } from '@/util/constants/orders.js';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import PaginationOnServerMixin from '@/mixins/paginationOnServerMixin';

export default {
  name: 'LiquidationTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
    BasePagination,
    RouteBreadCrumb,
  },

  mixins: [PaginationOnServerMixin],

  props: {
    distributorSelected: {
      type: Number,
      default: 0,
    },

    sellerSelected: {
      type: Number,
      default: 0,
    },

    campaignSelected: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      orders: [],
      modelName: 'orders',
    };
  },

  watch: {
    distributorSelected() {
      this.fetchTableData();
    },

    sellerSelected() {
      this.fetchTableData();
    },

    campaignSelected() {
      this.fetchTableData();
    },
  },

  mounted() {
    this.fetchTableData();
  },

  methods: {
    fetchTableData() {
      this.pagination.currentPage = this.page || this.pagination.currentPage;
      const params = {
        'filter[state]': STATE_FINALIZED,
        include: ['producer.distributor.seller', 'items.article', 'campaign'],
        append: ['total', 'total-in-pesos', 'commission'],
        perPage: this.pagination.perPage,
        page: this.pagination.currentPage,
      };
      this.$services
        .resource('orders')
        .get(params)
        .then((res) => {
          this.setMeta(res.data.meta);
          this.orders = res.data.data.orders;
        });
    },
  },
};
</script>
